<!--
  --
  -- 乗り捨て先選択カード
  --
  -->
<template>
  <v-card>
    <v-card-title>乗り捨て先</v-card-title>

    <!-- 乗り捨て先一覧 -->
    <v-list two-line
      style="max-height: calc(90vh - 110px)"
      class="v-scroll"
    >
      <v-list-item-group
        mandatory
        :value="value"
        @change="$emit('change', $event)"
        color="primary"
      >
        <v-list-item
          v-for="station in stations"
          :key="station.stationID"
          :value="station.stationID"
        >

          <v-list-item-content>
            <v-list-item-title v-text="station.name" />
            <v-list-item-subtitle v-text="station.address" />
          </v-list-item-content>

        </v-list-item>
      </v-list-item-group>
    </v-list>

    <!-- アクション -->
    <v-card-actions>
      <v-spacer/>

      <v-btn text @click="$emit('close')">閉じる</v-btn>
    </v-card-actions>

  </v-card>
</template>

<script>
export default {
  name: 'CReturnsToCard',

  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    // 返却先ステーション一覧
    stations: {
      type: Array,
      required: true
    },

    // 値: ステーションID
    value: {
      type: Number,
      default: 0
    }
  }
}
</script>
